import type { RefObject } from 'react';
import { TaskAudioPlayer, TaskItemCard, TaskItemText } from '@/features/contribution-kit';
import type { TranscriptionPhraseCopy } from './transcription-phrase-copy';
import type { PhraseEntry } from './types';

type TranscriptionPhraseSourceCardProps = {
  t: Record<string, unknown>;
  copy: TranscriptionPhraseCopy;
  current: PhraseEntry;
  sourceLanguageLabel: string;
  isPlaying: boolean;
  audioRef: RefObject<HTMLAudioElement>;
  canvasRef: RefObject<HTMLCanvasElement>;
  onPlayAudio: () => void;
  onAudioEnded: () => void;
};

const audioType = (url: string) => (url.endsWith('.webm') ? 'audio/webm' : url.endsWith('.ogg') ? 'audio/ogg' : 'audio/wav');

/** The phrase to translate, its language, and its recording when it has one. */
export function TranscriptionPhraseSourceCard({
  t,
  copy,
  current,
  sourceLanguageLabel,
  isPlaying,
  audioRef,
  canvasRef,
  onPlayAudio,
  onAudioEnded,
}: TranscriptionPhraseSourceCardProps) {
  return (
    <TaskItemCard label={copy.sourceLabel} corner={<span className="text-xs text-muted-foreground">{sourceLanguageLabel}</span>}>
      <TaskItemText>{current.text || current.frenchText || copy.notProvided}</TaskItemText>
      {current.audioUrl ? (
        <>
          <TaskAudioPlayer
            isPlaying={isPlaying}
            onToggle={onPlayAudio}
            canvasRef={canvasRef}
            playLabel={String(t.playAudio ?? '')}
            pauseLabel={String(t.pauseAudio ?? '')}
          />
          <audio key={current.id} ref={audioRef} onEnded={onAudioEnded} className="hidden">
            <source src={current.audioUrl} type={audioType(current.audioUrl)} />
          </audio>
        </>
      ) : null}
    </TaskItemCard>
  );
}
